var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LayoutError',[_c('div',{staticClass:"mt-4",attrs:{"id":"404"}},[_c('p',{staticClass:"text-center"},[_vm._v(" "+_vm._s(_vm.$t('page.error'))+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }